import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
export var countryAcknowledgementWrap = /*#__PURE__*/css("background:", colour.allhomesNavy900, ";padding:0 24px 32px;");
export var countryAcknowledgement = {
  name: "3pshem",
  styles: "text-align:center;width:100%;max-width:1020px;margin:0 auto;"
};
export var image = {
  name: "8atqhb",
  styles: "width:100%;"
};
export var text = /*#__PURE__*/css("color:", colour.white, ";font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";line-height:", font.smallMobileLineHeight, ";margin-top:10px;");
export var quote = /*#__PURE__*/css(text, ";font-size:14px;color:", colour.neutral100, ";");
export var artworkBy = /*#__PURE__*/css(quote, ";font-weight:", font.headingFontWeight, ";");